<template>
	<div>
		<nav class="navbar bg-light fixed-top">
			<div class="container">
				<div class="nav-logo-wrapper">
					<button class="navbar-toggler navbar-toggler-custom" v-on:click="navOpen = !navOpen;"
						v-bind:class="{ active: navOpen }" type="button">
						<span></span>
						<span></span>
						<span></span>
					</button>
					<hr v-if="mainSettings.logo" class="vertical-line" />
					<a class="navbar-brand" href="#">
						<img v-if="mainSettings.logo" :src="`${mainSettings.logo}`" alt="Logo" />
					</a>

					<div class="offcanvas-custom" id="mainNavbar" aria-labelledby="mainNavbarLabel"
						v-bind:class="{ show: navOpen }">
						<div class="offcanvas-body-custom">
							<ul class="navbar-nav justify-content-end flex-grow-1 pe-3 navbar-nav-custom">
								<template v-for="(navlink, index) in navigationData">
									<li v-if="navlink.config.pictures != '' && navlink.config.title != '' && navlink.type != 'freeTexts'"
										:key="index" class="nav-item nav-item-custom">
										<a class="nav-link nav-link-custom" v-on:click="navOpen = !navOpen;"
											:href="['#container-' + index + '-' + navlink.type]" :class="{ active: index == '0' }">{{
												navlink.config.title
											}}</a>
									</li>
									<template v-else-if="navlink.type == 'freeTexts'">
										<template v-for="(field, index) in navigationData[index].config
										.fields">
											<li :key="index" v-if="field.type != ''" class="nav-item nav-item-custom">
												<a v-on:click="navOpen = !navOpen;" class="nav-link nav-link-custom"
													:href="['#container-' + index + '-' + field.type]">{{ field.title }}</a>
											</li>
										</template>
									</template>
								</template>
							</ul>
						</div>
					</div>
				</div>
				<div class="navbar-contact">
					<template v-for="(mainSettings, index) in mainSettings.footnote">
						<div v-if="index == 'e-mail' && mainSettings.value != ''" :key="index">
							<div class="col-12 email-field">
								<a :href="'mailto:' + mainSettings.value">
									<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path fill-rule="evenodd" clip-rule="evenodd"
											d="M3.00977 5.83789C3.00977 5.28561 3.45748 4.83789 4.00977 4.83789H20C20.5523 4.83789 21 5.28561 21 5.83789V17.1621C21 18.2667 20.1046 19.1621 19 19.1621H5C3.89543 19.1621 3 18.2667 3 17.1621V6.16211C3 6.11449 3.00333 6.06765 3.00977 6.0218V5.83789ZM5 8.06165V17.1621H19V8.06199L14.1215 12.9405C12.9499 14.1121 11.0504 14.1121 9.87885 12.9405L5 8.06165ZM6.57232 6.80554H17.428L12.7073 11.5263C12.3168 11.9168 11.6836 11.9168 11.2931 11.5263L6.57232 6.80554Z"
											fill="currentColor" />
									</svg>
								</a>
							</div>
						</div>
					</template>
					<template v-for="(data, index) in mainSettings" :key="index">
						<hr v-if="(data.telefon && data.telefon.value && data['e-mail'] && data['e-mail'].value)"
							class="vertical-line" />
					</template>
					<template v-for="(mainSettings, index) in mainSettings.footnote">
						<div v-if="index == 'telefon' && mainSettings.value != ''" :key="index">
							<div class="col-12 phone-field">
								<a :href="'tel:' + mainSettings.value">
									<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path
											d="M22 12C22 10.6868 21.7413 9.38647 21.2388 8.1731C20.7362 6.95996 19.9997 5.85742 19.0711 4.92896C18.1425 4.00024 17.0401 3.26367 15.8268 2.76123C14.6136 2.25854 13.3132 2 12 2V4C13.0506 4 14.0909 4.20703 15.0615 4.60889C16.0321 5.01099 16.914 5.60034 17.6569 6.34326C18.3997 7.08594 18.989 7.96802 19.391 8.93848C19.7931 9.90918 20 10.9495 20 12H22Z"
											fill="currentColor" />
										<path
											d="M2 10V5C2 4.44775 2.44772 4 3 4H8C8.55228 4 9 4.44775 9 5V9C9 9.55225 8.55228 10 8 10H6C6 14.4182 9.58173 18 14 18V16C14 15.4478 14.4477 15 15 15H19C19.5523 15 20 15.4478 20 16V21C20 21.5522 19.5523 22 19 22H14C7.37259 22 2 16.6274 2 10Z"
											fill="currentColor" />
										<path
											d="M17.5433 9.70386C17.8448 10.4319 18 11.2122 18 12H16.2C16.2 11.4485 16.0914 10.9023 15.8803 10.3928C15.6692 9.88306 15.3599 9.42017 14.9698 9.03027C14.5798 8.64014 14.1169 8.33081 13.6073 8.11963C13.0977 7.90869 12.5515 7.80005 12 7.80005V6C12.7879 6 13.5681 6.15527 14.2961 6.45679C15.024 6.7583 15.6855 7.2002 16.2426 7.75732C16.7998 8.31445 17.2418 8.97583 17.5433 9.70386Z"
											fill="currentColor" />
									</svg>
								</a>
							</div>
						</div>
					</template>
				</div>
			</div>
		</nav>
		<div v-bind:class="{ backdrop: navOpen }" v-on:click="navOpen = !navOpen;"></div>
	</div>
</template>

<script>
export default {
	props: {
		navigationData: {
			type: Object,
		},
		mainSettings: {
			type: Object,
		},
	},
	data() {
		return {
			navOpen: false,
		};
	},
	methods: {
		clickOnBackdrop() {
			// if (this.navOpen) {
			//   var backdrop = document.querySelector(".offcanvas-backdrop");
			//   backdrop.addEventListener("click", this.closeNavigation);
			// }
		},
		closeNavigation() {
			this.navOpen = false;
		},
	},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-turin/navigationComponent.scss";
</style>
